module.exports = __webpack_public_path__ + "files/383f6de9a8111c34e980e112cec6728e.png";